import { GTM_ERROR_CODES } from '../error-codes';

(() => {
    document.addEventListener('Club_Member_Acquisition_Lead', () => {
        window.dataLayerPushDeferred({
            event: 'generate_lead',
            event_type: 'dni-socio',
        });
    });

    document.addEventListener('Club_Member_Acquisition_Lead_Error', () => {
        window.dataLayerPushDeferred({
            event: 'error_interaction',
            error_id: GTM_ERROR_CODES.ERROR_FORM_CLUB_MEMBER_ACQUISITION_LEAD,
        });
    });
})();
